@if (!hidePopupLayoutElements) {
  <section mat-dialog-title>
    <h1>
      <span id="dialogTitle">{{ title }}</span>
      <mat-icon id="dialogTitleIcon">{{ icon }}</mat-icon>
    </h1>
  </section>
}
<section mat-dialog-content>
  @if (templateRef) {
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
  } @else {
    <span id="dialogMessage" [innerHTML]="message"></span>
  }
</section>
@if (!hidePopupLayoutElements) {
  <section mat-dialog-actions class="pull-right">
    @if (displayCancel) {
      <button id="cancelBtn" mat-button (click)="onCancel()" data-role="cancel">{{ cancel | translate }}</button>
    }
    <button id="confirmBtn" color="primary" mat-raised-button cdkFocusInitial [disabled]="!canConfirm" data-role="confirm" (click)="onConfirm()">
      {{ confirm }}
    </button>
  </section>
}
